import type { RootSearch } from '@/routes/__root'

// One derivation, so the layout's context and the panel's search cannot disagree about the key.
export function jobIntegrantsSource(first: RootSearch['first']): 'described' | 'integrants' {
  return first?.type === 'job' && 'source' in first && first.source === 'integrants' ? 'integrants' : 'described'
}
